import React from 'react';
import './DeliveryTypes.scss';
import './DeliveryTypes-media.scss';
import { MediaContent } from '../../services/GlobalFunctions';
import { Props } from './interfaces';
import CardHoverPoint from '../CardHoverPoint/CardHoverPoint';

const DeliveryTypes = ({ title, list }: Props) => {
  const cards = (
    <>
      {list.map((item, i) => (
        <CardHoverPoint {...item} key={i} />
      ))}
    </>
  );

  return (
    <div className="delivery-types">
      <div className="delivery-types__title">
        <h2>{title}</h2>
      </div>
      {MediaContent(<div className="delivery-types__bg"></div>, null)}
      {MediaContent(cards, <div className="delivery-types__slider">{cards}</div>)}
    </div>
  );
};

export default DeliveryTypes;
